import { Flex } from 'antd';
import { useInjection } from 'inversify-react';

import { Button, Icon, Text, useTheme } from '@desygner/ui-common-components';
import { useTranslation } from '@desygner/ui-common-translation';

import { RestrictionsManager } from '../../../../../../core/viewer/restrictions-manager';
import { TYPES } from '../../../../../../inversify.types';
import { useCreateProject } from '../../../../../hooks/useCreateProject';

export type UseProjectProps = {
  type: 'bottomsheet' | 'desktop';
};

export const UseProject = ({ type }: UseProjectProps) => {
  const theme = useTheme();
  const { t } = useTranslation();

  const { createProjectAsync, status: createProjectStatus } = useCreateProject();
  const restrictionsManager = useInjection<RestrictionsManager>(TYPES.Viewer.RestrictionsManager);

  async function handleCreateFromTemplate() {
    restrictionsManager.createProjectAndNavigateToEditor(createProjectAsync);
  }

  if (type === 'desktop') {
    return (
      <Button
        action="create-from-template"
        loading={createProjectStatus === 'pending'}
        disabled={createProjectStatus === 'pending'}
        onClick={handleCreateFromTemplate}
        variant="outline"
      >
        {t('tool.topbar.use_button')}
      </Button>
    );
  }

  return (
    <Flex data-testid="use-template" data-action={'create-from-template'} role="button" onClick={handleCreateFromTemplate}>
      <Flex gap={theme.Sizes.Small} flex={1}>
        <Icon name="edit---3" color={theme.Color.Neutrals.Text} />
        <Text size="Body">{t('tool.topbar.use_button')}</Text>
      </Flex>
    </Flex>
  );
};
